export default __webpack_public_path__ + "static/media/04.8715f843.webp";